/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AppointmentQueryOperatorV1 {
    AND = 'AND',
    OR = 'OR',
}